import type { ComponentProps } from "react"

export type PlacepointLogoProps = ComponentProps<"svg">

function PlacepointLogo(props: PlacepointLogoProps) {

  const {
    fill = "#6fff90",
    width = 24,
    height = 24,
    ...svgProps
  } = props

  return (
    <svg
      width={width}
      height={height}
      viewBox="294 0 238.2 318.6"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <polygon
        fill={fill}
        points="294.1 57.2 294.1 276.2 367.5 318.6 380.4 311.1 380.4 92.2 307 49.8 294.1 57.2"
      />
      <polygon
        fill={fill}
        points="393.3 0 380.4 7.4 380.4 92.2 445.9 130 445.9 225.1 458.7 232.6 532.2 190.2 532.2 80.2 393.3 0"
      />
    </svg>
  )
}

export default PlacepointLogo
